import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectAppUser, selectIsLoading } from '../../state/selectors/app';
import { PrivateRoute } from '../privateRoute.jsx';
import { Route, Switch, Redirect } from 'react-router-dom';
import UserList from "../../pages/UserManagement/users";
import EditUser from "../../pages/UserManagement/edit_user";
import LimitList from "../../pages/Limits";
import TanksPage from "../../pages/Tanks/tanks_page";
import EditTank from "../../pages/Tanks/tank/edit_tank";
import OperationList from "../../pages/Operations";
import LoginPage from "../../pages/Login";
import TankDetails from "../../pages/Tanks/tank/tank_details.jsx"
import EditTankOperation from "../../pages/Tanks/tank_operation/edit_tank_operation.jsx"
import AddAreaView from "../../pages/Tanks/area/add_area_view.jsx"
import Loader from '../loader/loader.jsx';
import { AccessLevel, AppModules } from '../../constants/appAccess';
import RolesList from '../../pages/RoleManagement/roles';
import EditRole from '../../pages/RoleManagement/edit_role';
import OrderHistoryList from '../../pages/OrderHistory/index.js';
import CardsPage from '../../pages/Cards/index.js';

const mapStateToProps = () => {
    return createStructuredSelector({
        user: selectAppUser(),
        loading: selectIsLoading()
    });
}

const Dashboard = (props) => {
    const {loading, user} = props
    return (
        <div>
            <Switch>
                <Route exact path="/login" component={LoginPage} />
                <PrivateRoute path="/cards" access={AccessLevel.Read} moduleName={AppModules.Cards} component={CardsPage} />
                <PrivateRoute exact path="/limits" component={LimitList} />
                <PrivateRoute exact path="/tanks" component={TanksPage} />
                <PrivateRoute exact path="/tanks/tanks" component={TanksPage} />
                <PrivateRoute exact path="/tanks/tanksoperations" component={TanksPage} />
                <PrivateRoute exact path="/tanks/tankstates" component={TanksPage} />
                <PrivateRoute path="/tanks/:areaId/addTank/" component={EditTank} />
                <PrivateRoute path="/tanks/addArea/" component={AddAreaView} />
                <PrivateRoute path="/tanks/tankdetails/:id" component={TankDetails} />
                <PrivateRoute path="/tanks/editTank/:id" component={EditTank} />
                <PrivateRoute path="/tanks/:id/addtankoperation" component={EditTankOperation} />
                <PrivateRoute exact path="/operations" component={OperationList} />
                <PrivateRoute exact path="/orderHistory" access={AccessLevel.Read} moduleName={AppModules.OrderHistory} component={OrderHistoryList} />
                <PrivateRoute exact path="/users" access={AccessLevel.Read} moduleName={AppModules.Administration} component={UserList} />
                <PrivateRoute path="/users/addUser" access={AccessLevel.Write} moduleName={AppModules.Administration} component={EditUser} />
                <PrivateRoute path="/users/editUser/:id" access={AccessLevel.Write} moduleName={AppModules.Administration} component={EditUser} />
                <PrivateRoute exact path="/roles" access={AccessLevel.Read} moduleName={AppModules.Administration} component={RolesList} />
                <PrivateRoute path="/roles/addRole" access={AccessLevel.Write} moduleName={AppModules.Administration} component={EditRole} />
                <PrivateRoute path="/roles/editRole/:roleName" access={AccessLevel.Write} moduleName={AppModules.Administration} component={EditRole} />
                <Redirect from="/" to="/operations" />
            </Switch>
            {loading && <Loader />}
        </div>
    )
}

export default connect(mapStateToProps)(Dashboard);